<template>
  <AppBanner>
    Edit Framework
  </AppBanner>

  <template v-if="loading">
    <AppContentLoader :is-loading="loading" />
  </template>

  <template v-else-if="!framework">
    <h1 class="flex items-center justify-center h-full">
      Unable to load framework. Please try again.
    </h1>
  </template>

  <template v-else>
    <FrameworkForm :model="framework" />
  </template>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

import { AppContentLoader } from '@/components/app';
import { AppBanner } from '@/components/banners';
import { FrameworkForm } from '@/components/forms';

import { useHttp } from '@/composables';

const route = useRoute();

const loading = ref(true);
const error = ref(null);
const framework = ref(null);

onMounted(async () => {
  await loadFramework();
});

const loadFramework = async () => {
  const response = await useHttp().get(`/frameworks/${route.params.framework}`);

  if (response.statusCode === HttpStatusCode.Ok) {
    framework.value = response.data;
  } else {
    error.value = response.exception;
  }

  loading.value = false;
};
</script>
